// extracted by mini-css-extract-plugin
export default {"componentWrapper":"FileCardList_componentWrapper__hJjjk","filePlaceholder":"FileCardList_filePlaceholder__WWHFz"};